module.exports = __webpack_public_path__ + "img/logo_circle.e89c0a66.png";